import { DataRoomActivityWindow, FileActivityPage, FileActivityRow } from 'shared';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { ApiService } from '../../../../services/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';
import { Order } from '../../../../types/general.types';
import { ACTIVITY_PAGE_SIZE, ActivityPages, useActivityPages } from './use-activity-pages.hook';

const fileKey = ({ fileId }: FileActivityRow): string => fileId;

/** 20.1.3 §5: the four columns a reader may re-sort by, matching the server's allowlist. */
export enum FileSortColumn {
  DATA_ROOM = 'data-room',
  DOWNLOADS = 'downloads',
  UNIQUE_VIEWS = 'unique-views',
  VIEWS = 'views',
}

export type FileActivityFilters = {
  dataRoomId?: string;
  search?: string;
  sortBy: FileSortColumn;
  sortOrder: Order;
  window: DataRoomActivityWindow;
};

/**
 * The Files tab — 20.1.3.
 *
 * The trend arrow arrives decided: it is the server comparing the window with the one before it,
 * not a second request this tab makes per row.
 */
export const useActivityFiles = (filters: FileActivityFilters): ActivityPages<FileActivityPage> => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  return useActivityPages({
    fetchPage: (skip: number) =>
      ApiService.get<FileActivityPage>(
        { endpoint: BackendRoute.DATA_ROOM_ACTIVITY, routePath: ['files'] },
        {
          queryParams: {
            ...(filters.dataRoomId ? { dataRoomId: filters.dataRoomId } : {}),
            ...(filters.search ? { search: filters.search } : {}),
            skip,
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            take: ACTIVITY_PAGE_SIZE,
            window: filters.window,
          },
        },
      ),
    queryKey: [QueryKey.GET_DATA_ROOM_ACTIVITY_FILES, companyId, filters],
    rowKey: fileKey,
    scope: [QueryKey.GET_DATA_ROOM_ACTIVITY_FILES, companyId],
  });
};
